/*
** DO NOT EDIT THIS FILE! All changes will be overwritten.
** edit the master in app/javascript/themes/aagarage/_aagarage_theme.js,
** then run script/activate-theme aagarage
*/

//
//
//     ##      ##     ####     ##    #####     ##     ####   ######
//    #  #    #  #   #    #   #  #   #    #   #  #   #    #  #
//   #    #  #    #  #       #    #  #    #  #    #  #       #####
//   ######  ######  #  ###  ######  #####   ######  #  ###  #
//   #    #  #    #  #    #  #    #  #   #   #    #  #    #  #
//   #    #  #    #   ####   #    #  #    #  #    #   ####   ######
//

// This file is installed into config/javascript/canyoneroTheme.js
// run script/activate-theme after making any changes

export const SITE_CONFIG = {
  siteName: 'aagarage',
  theme: {
    siteName: 'aagarage',
    displayName: "AutoAccessoriesGarage",
    saveCartLogo: "/img/logo/aag-logo-drk-med.png",
    mailingListName: "AAG Insiders Mailing List",
    pathPrefix: "", // for LocalUrlMaker
    freeShipping: true,
  },
  classLists: {
    // clustered product selector
    ItemCluster: '',
    'CheckoutButton.common': [
      'btn-gray py-2 w-full'
    ],
    'CheckoutButton.main': [
      'btn-primary !text-white',
    ],

  }
}


/*
** config/javascript/canyoneroTheme.js
** installed by ./script/activate-theme aagarage
** at Mon Oct 19 09:22:41 PM UTC 2026 on homer07
*/
